import React from "react";
import "../css/appStyling.css";

// banner images
import WeatherManAppPreview from "../Assets/previewsProject/preview-weatherManApp.webp";
import defaultProjectImage from "../Assets/previewsProject/defaultProjectImage_2x.webp";
import readAQuote from "../Assets/previewsProject/read-a-quote.webp";
import textUtils from "../Assets/previewsProject/textUtils.webp";

// back links
import BackToHome from "./BackToHome";
import EachProject from "./EachProject";
import Navbar from "./Navbar";

// components
import EachWebsiteLeftImage from "./EachWebsiteLeftImage";
import EachWebsiteRightImage from "./EachWebsiteRightImage";

// Each website banners

import prismClubBanner from "../Assets/websites/webp/thumbnail.webp";
import acceptMeBanner from "../Assets/websites/webp/thumbnail-1.webp";
import liveLinguisticBanner from "../Assets/websites/webp/thumbnail-5.webp";
import ksureshBanner from "../Assets/websites/webp/thumbnail-4.webp";
import erBanner from "../Assets/websites/webp/thumbnail-3.webp";
import osojiBanner from "../Assets/websites/webp/thumbnail-2.webp";
import trbBlogBanner from "../Assets/websites/webp/trbBlog.webp";

function Projects() {
  return (
    <>
      <Navbar style={{ background: "#333" }} />
      <div className="my-projects bg-light-custom" id="myProjects">
<div className="text-center">
<h1 className="title pt-3 d-inline-block">My Projects</h1>
</div>
        <h3 className="text-center text-dark-purple cursive-underline">
          Using ReactJS
        </h3>

        <section className="allProjectsContainer container-fluid p-0">
          <div className="align-items-start d-flex flex-wrap justify-content-center pt-3 mb-5">
            <EachProject
              projectLink="/projects/weatherManApp"
              imageSrc={WeatherManAppPreview}
              projectTitle="WeatherManApp"
            />
            <EachProject
              projectLink="/projects/read-a-quote"
              imageSrc={readAQuote}
              projectTitle="Inpiring Quotes"
            />
            {/* <EachProject
              projectLink="/projects/MovieDataBase"
              imageSrc={defaultProjectImage}
              projectTitle="Explore new movies"
            /> */}
            <EachProject
              projectLink="/projects/TextUtilities"
              imageSrc={textUtils}
              projectTitle="Text Utilities"
            />
          </div>

          <div>
            <h3 className="py-5 text-center text-dark-purple cursive-underline m-0 bg-light-purple">
              Commissioned Works
            </h3>
            <p className="text-center bg-light-purple m-0 p-0">
              These websites are the result of my creative touch and development
              work for various clients.
            </p>
            <EachWebsiteLeftImage
              websiteBgColor="#F0EBFF"
              websiteTitleColor="#5900FF"
              websiteBanner={prismClubBanner}
              websiteTitle="Prism Club & Kitchen"
              websiteInfo="Prism Club and Kitchen is the first-of-its-kind super nightclub in Hyderabad, rated among one of the best in the world."
              websiteURL="www.prismclubs.com"
            />

            <EachWebsiteRightImage
              websiteBgColor="#FAF1EF"
              websiteTitleColor="#E34234"
              websiteBanner={liveLinguisticBanner}
              websiteTitle="LiveLinguistic"
              websiteInfo="LiveLinguistic makes a language learning easy and effective for you."
              websiteURL="livelinguistic.vercel.app"
            />

            <EachWebsiteLeftImage
              websiteBgColor="#FCEEF5"
              websiteTitleColor="#F50C92"
              websiteBanner={acceptMeBanner}
              websiteTitle="Accept Me"
              websiteInfo="AcceptMe website was an efficient website to help you accept all your pending requests on your Instagram profile in a very convenient way."
              websiteURL="web.archive.org/web/20220507094001/https://acceptme.in"
            />

            <EachWebsiteRightImage
              websiteBgColor="#EDF2FD"
              websiteTitleColor="#0079FF"
              websiteBanner={erBanner}
              websiteTitle="Resolute Email Marketing Solutions"
              websiteInfo="A one-stop solution to all your email marketing issues"
              websiteURL="www.emailresolute.com"
            />
            <EachWebsiteLeftImage
              websiteBgColor="#f1f8f1"
              websiteTitleColor="#2d5d2d"
              websiteBanner={osojiBanner}
              websiteTitle="Osoji Services"
              websiteInfo="An ISO certified Commercial Kitchen Hood And Duct Cleaning Services In Pan Asia."
              websiteURL="www.osojiservices.com"
            />
                    <EachWebsiteRightImage
              websiteBgColor="#ffefeb"
              websiteTitleColor="#ff5724"
              websiteBanner={ksureshBanner}
              websiteTitle="Sri Satyanarayana Goods Transport"
              websiteInfo="Sri Satyanarayana Goods Transport is One of the best goods transport companies located at Armoor, Nizamabad District, Telangana State having 30+ years of experience in the field of goods service since 1985."
              websiteURL="www.khandeshsuresh.com"
            />
                  <EachWebsiteLeftImage
              websiteBgColor="#f5f5f5"
              websiteTitleColor="#4a4a4a"
              websiteBanner={trbBlogBanner}
              websiteTitle="TRB’s Weekly Blog"
              websiteInfo="TRB, aka TEEAARBEE is a Professional Video Editor, Memer and A Blogger, who has worked with brands like Netflix, Google, Instagram, Facebook and many more"
              websiteURL="blog.teeaarbee.com"
            />
          </div>
        </section>

        <BackToHome />
      </div>
    </>
  );
}

export default Projects;
